/**
 * Knosen Theme JavaScript
 * Handles sticky header shrinking behavior and collection name translations
 * 
 * ============================================
 * COLLECTION NAME TRANSLATIONS
 * ============================================
 * 
 * Translates collection handles to display names
 */

const COLLECTION_NAME_MAP = {
  'all': 'EVERYTHING',
  'antique-sleigh-beds': 'BEDS',
  'tables': 'TABLES',
  'seating': 'SEATING',
  'storage': 'STORAGE',
  'accessories': 'ACCESSORIES',
  'art': 'ART',
  'extra-large': 'EXTRA LARGE',
  'baskets': 'BASKETS'
};

function translateCollectionName(collectionHandle) {
  return COLLECTION_NAME_MAP[collectionHandle] || collectionHandle.toUpperCase().replace(/-/g, ' ');
}

// Apply translations on page load
document.addEventListener('DOMContentLoaded', function() {
  // Translate main collection title
  const collectionTitle = document.querySelector('.collection-container h1');
  if (collectionTitle && collectionTitle.dataset.handle) {
    const translatedName = translateCollectionName(collectionTitle.dataset.handle);
    // Check if breadcrumb structure exists
    const breadcrumbCurrent = collectionTitle.querySelector('.breadcrumb-current');
    if (breadcrumbCurrent) {
      // Update only the current collection name in breadcrumb
      breadcrumbCurrent.textContent = translatedName;
    } else {
      // No breadcrumb, update entire h1
      collectionTitle.textContent = translatedName;
    }
  }
  
  // Translate category tile titles
  document.querySelectorAll('.category-tile-title').forEach(function(title) {
    if (title.dataset.handle) {
      title.textContent = translateCollectionName(title.dataset.handle);
    }
  });
  
  // Initialize sticky header on all pages
  initStickyHeader();
  
  // Initialize collection filtering
  initFacetFilters();
  
  // Initialize category carousel
  initCategoryCarousel();
  
  // Initialize mobile menu
  initMobileMenu();
  
  // Initialize mobile filter menu
  initMobileFilterMenu();
  
  // Initialize search modal
  initSearchModal();
  
  // Initialize product gallery
  initProductGallery();
  
  // Initialize quantity selector
  initQuantitySelector();
  
  // Initialize footer scroll detection
  initFooterScrollDetection();
  
  // Initialize shop dropdown for touch devices
  initShopDropdown();
  
  // Initialize parallax effect for Made collection
  initMadeParallax();
  
  // Initialize smooth scroll for anchor links
  initSmoothScroll();
  
  // Initialize FAQ accordion
  initFaqAccordion();
  
  // Initialize product specs accordion
  initSpecsAccordion();
  
  // Initialize category product loader (AJAX) on home page only
  if (document.body.classList.contains('template-index')) {
    initCategoryProductLoader();
  }
  
  // Initialize category tile image swapping for shop page
  initCategoryTileImageSwap();
});

/**
 * ============================================
 * SHOPIFY FACET FILTERS (AJAX)
 * ============================================
 */

function initFacetFilters() {
  const form = document.getElementById('FacetFiltersForm');
  if (!form) return;
  
  const filterToggles = document.querySelectorAll('.filter-toggle');
  const filterResets = document.querySelectorAll('.filter-reset');
  const sortSelect = document.getElementById('SortBy');
  
  // Toggle filter dropdowns
  filterToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const filterName = this.dataset.filter;
      const dropdown = document.getElementById(filterName + '-dropdown');
      const isActive = dropdown && dropdown.classList.contains('active');
      
      // Close all dropdowns
      document.querySelectorAll('.filter-dropdown').forEach(function(d) {
        d.classList.remove('active');
      });
      
      // Toggle aria-expanded
      filterToggles.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
      
      // Open this dropdown if it wasn't active
      if (!isActive && dropdown) {
        dropdown.classList.add('active');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });
  
  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.filter-group')) {
      document.querySelectorAll('.filter-dropdown').forEach(function(d) {
        d.classList.remove('active');
      });
      filterToggles.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
    }
  });
  
  // Handle filter checkbox changes (availability)
  form.addEventListener('change', function(e) {
    if (e.target.classList.contains('filter-checkbox')) {
      onFilterChange();
    }
  });
  
  // Handle price input changes with debounce
  let priceTimeout;
  const priceInputs = document.querySelectorAll('.price-input');
  priceInputs.forEach(function(input) {
    input.addEventListener('input', function() {
      clearTimeout(priceTimeout);
      priceTimeout = setTimeout(function() {
        onFilterChange();
      }, 500);
    });
    
    // Also trigger on Enter key
    input.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(priceTimeout);
        onFilterChange();
      }
    });
  });
  
  // Handle sort change
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      onFilterChange();
    });
  }
  
  // Handle reset buttons
  filterResets.forEach(function(resetBtn) {
    resetBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const filterName = this.dataset.filter;
      
      if (filterName === 'price') {
        // Reset price inputs
        document.getElementById('Filter-Price-GTE').value = '';
        document.getElementById('Filter-Price-LTE').value = '';
      } else {
        // Reset other filter checkboxes
        const checkboxes = document.querySelectorAll('[name^="filter.v.' + filterName + '"]');
        checkboxes.forEach(function(cb) { cb.checked = false; });
      }
      
      onFilterChange();
    });
  });
  
  // Handle active filter tag clicks
  document.addEventListener('click', function(e) {
    if (e.target.closest('.active-filter-tag') || e.target.closest('.clear-all-filters')) {
      e.preventDefault();
      const href = e.target.closest('a').getAttribute('href');
      fetchFilteredCollection(href);
    }
  });
  
  // Handle pagination clicks
  document.addEventListener('click', function(e) {
    const paginationLink = e.target.closest('.pagination-link');
    if (paginationLink && paginationLink.tagName === 'A') {
      e.preventDefault();
      const href = paginationLink.getAttribute('href');
      fetchFilteredCollection(href);
    }
  });
}

function onFilterChange() {
  const form = document.getElementById('FacetFiltersForm');
  const formData = new FormData(form);
  const searchParams = new URLSearchParams(formData).toString();
  const sectionUrl = window.location.pathname + '?' + searchParams;
  
  fetchFilteredCollection(sectionUrl);
}

function fetchFilteredCollection(url) {
  // Show loading overlay
  const loadingOverlay = document.querySelector('.loading-overlay');
  if (loadingOverlay) {
    loadingOverlay.classList.add('active');
  }
  
  // Add section_id parameter for Section Rendering API
  const urlObj = new URL(url, window.location.origin);
  urlObj.searchParams.set('section_id', 'main-collection');
  
  fetch(urlObj.toString())
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      // Parse the returned HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Replace the collection section
      const newSection = doc.getElementById('main-collection');
      const currentSection = document.getElementById('main-collection');
      
      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
        
        // Re-translate collection title
        const collectionTitle = document.querySelector('.collection-container h1');
        if (collectionTitle && collectionTitle.dataset.handle) {
          const translatedName = translateCollectionName(collectionTitle.dataset.handle);
          const breadcrumbCurrent = collectionTitle.querySelector('.breadcrumb-current');
          if (breadcrumbCurrent) {
            breadcrumbCurrent.textContent = translatedName;
          } else {
            collectionTitle.textContent = translatedName;
          }
        }
        
        // Reinitialize filters on the new content
        initFacetFilters();
      }
      
      // Update URL without reload
      window.history.pushState({ path: url }, '', url);
      
      // Hide loading overlay
      if (loadingOverlay) {
        loadingOverlay.classList.remove('active');
      }
      
      // Scroll to top of products
      const collectionContainer = document.querySelector('.collection-container');
      if (collectionContainer) {
        const headerHeight = document.querySelector('.site-header').offsetHeight || 0;
        const scrollTarget = collectionContainer.offsetTop - headerHeight - 20;
        window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
      }
    })
    .catch(function(error) {
      console.error('Error fetching filtered collection:', error);
      if (loadingOverlay) {
        loadingOverlay.classList.remove('active');
      }
    });
}

/**
 * ============================================
 * HEADER ANIMATION CONFIGURATION GUIDE
 * ============================================
 * 
 * The header animation creates a smooth shrinking effect when scrolling.
 * Two key scroll points control the behavior:
 * 
 * POINT A: When the ANTIQUES section first touches the bottom of KNOSEN header
 * POINT B: When KNOSEN is fully shrunk and both headers become fixed/sticky
 * 
 * Between A and B:
 * - ANTIQUES continues scrolling naturally upward
 * - KNOSEN shrinks vertically (bottom edge moves up with scroll)
 * - Creates illusion of ANTIQUES "pushing" KNOSEN smaller
 * 
 * After B:
 * - Both headers are fixed in place
 * - They scroll together with the page
 * 
 * --------------------------------------------
 * CONFIGURATION VALUES TO ADJUST:
 * --------------------------------------------
 * 
 * 1. KNOSEN LOGO FONT SIZES (lines ~55-57)
 *    - maxFontSize: Starting size (default: 60px)
 *    - minFontSize: Final shrunk size (default: 32px)
 * 
 * 2. HEADER HEIGHTS (lines ~60-62)
 *    - maxHeaderHeight: Starting height (default: 80px)
 *    - minHeaderHeight: Final shrunk height (default: 50px)
 *    
 *    ⚠️  IMPORTANT: Also update CSS variables in theme.css:
 *        --header-height: 80px
 *        --header-height-shrunk: 50px
 * 
 * 3. TRANSITION DISTANCE (line ~67)
 *    - transitionDistance: Pixels of scroll between A and B
 *    - Default: headerHeightRange (30px = 80px - 50px)
 *    - Increase for slower transition, decrease for faster
 * 
 * 4. ANTIQUES SECTION STYLING
 *    - Background color is set in:
 *      • CSS: .antiques-header-section background-color
 *      • JS placeholder: line ~47 (must match CSS)
 * 
 * --------------------------------------------
 * WHAT DOESN'T NEED TO BE CHANGED:
 * --------------------------------------------
 * - Point A and B calculations (automatic based on above values)
 * - Scroll event listener logic
 * - Placeholder element handling
 * 
 * --------------------------------------------
 * TESTING CHECKLIST:
 * --------------------------------------------
 * After making changes, test:
 * 1. Scroll down slowly - smooth shrinking?
 * 2. Scroll up slowly - smooth expanding?
 * 3. No content jumps at point B?
 * 4. Works on mobile viewport sizes?
 * 5. ANTIQUES background color matches placeholder?
 */

/**
 * Simple header shrink for non-homepage pages
 * Header shrinks after scrolling past a threshold (400px)
 */
function initSimpleHeaderShrink(header) {
  const logo = header.querySelector('.logo');
  const SCROLL_THRESHOLD = 400;
  const TRANSITION_DISTANCE = 30; // Pixels over which to animate the shrink
  
  function getCurrentHeaderSizes() {
    const logoHeight = parseFloat(window.getComputedStyle(logo).height);
    const headerHeight = parseFloat(window.getComputedStyle(header).height);
    
    return {
      maxLogoHeight: logoHeight,
      minLogoHeight: 32,
      maxHeaderHeight: headerHeight,
      minHeaderHeight: 50
    };
  }
  
  let sizes = getCurrentHeaderSizes();
  let logoHeightRange = sizes.maxLogoHeight - sizes.minLogoHeight;
  let headerHeightRange = sizes.maxHeaderHeight - sizes.minHeaderHeight;
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop < SCROLL_THRESHOLD) {
      // Not scrolled enough - keep header large
      logo.style.height = '';
      header.style.height = '';
      header.classList.remove('shrink');
      document.body.classList.remove('header-shrunk');
      
    } else if (scrollTop >= SCROLL_THRESHOLD && scrollTop < SCROLL_THRESHOLD + TRANSITION_DISTANCE) {
      // In transition zone - gradually shrink
      const scrollProgress = (scrollTop - SCROLL_THRESHOLD) / TRANSITION_DISTANCE;
      const currentLogoHeight = sizes.maxLogoHeight - (logoHeightRange * scrollProgress);
      const currentHeaderHeight = sizes.maxHeaderHeight - (headerHeightRange * scrollProgress);
      
      logo.style.height = Math.round(currentLogoHeight * 100) / 100 + 'px';
      header.style.height = Math.round(currentHeaderHeight * 100) / 100 + 'px';
      header.classList.remove('shrink');
      document.body.classList.remove('header-shrunk');
      
    } else {
      // Fully scrolled - keep header small
      logo.style.height = sizes.minLogoHeight + 'px';
      header.style.height = sizes.minHeaderHeight + 'px';
      header.classList.add('shrink');
      document.body.classList.add('header-shrunk');
    }
  }
  
  // Initial check
  handleScroll();
  
  // Scroll listener
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Recalculate on resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      sizes = getCurrentHeaderSizes();
      logoHeightRange = sizes.maxLogoHeight - sizes.minLogoHeight;
      headerHeightRange = sizes.maxHeaderHeight - sizes.minHeaderHeight;
      handleScroll();
    }, 100);
  });
}

/**
 * Initialize sticky header with shrinking behavior
 * The header shrinks when the ANTIQUES section reaches it on homepage,
 * or after 400px of scrolling on other pages
 */
function initStickyHeader() {
  const header = document.getElementById('site-header');
  const antiquesSection = document.querySelector('.antiques-section');
  const antiquesHeader = document.getElementById('antiques-header');
  const madeHeader = document.getElementById('made-header');
  
  if (!header) {
    console.error('site-header not found');
    return;
  }
  
  // Check if we're on the homepage with antiques section
  const hasAntiquesSection = antiquesSection && antiquesHeader;
  
  if (!hasAntiquesSection) {
    // Non-homepage: Simple scroll-based shrinking at 400px
    initSimpleHeaderShrink(header);
    return;
  }
  
  // MADE header is optional - feature might not be enabled
  const hasMadeHeader = !!madeHeader;
  
  console.log('Sticky header initialized', hasMadeHeader ? 'with MADE header' : '');
  
  // Create a placeholder to prevent content jump when ANTIQUES becomes fixed
  const antiquesPlaceholder = document.createElement('div');
  antiquesPlaceholder.style.display = 'none';
  antiquesPlaceholder.style.backgroundColor = '#A35A3B'; // Match the rust/terracotta color
  antiquesSection.parentNode.insertBefore(antiquesPlaceholder, antiquesSection);
  
  // Create placeholder for MADE header if it exists
  let madePlaceholder;
  if (hasMadeHeader) {
    madePlaceholder = document.createElement('div');
    madePlaceholder.style.display = 'none';
    madePlaceholder.style.backgroundColor = '#DBB181'; // Match caramel color
    madeHeader.parentNode.insertBefore(madePlaceholder, madeHeader);
  }
  
  // Ensure we measure from a clean state (in case page loaded while scrolled)
  antiquesHeader.classList.remove('is-stuck');
  antiquesHeader.style.top = '';
  antiquesPlaceholder.style.display = 'none';
  
  if (hasMadeHeader) {
    madeHeader.classList.remove('is-stuck');
    madeHeader.style.top = '';
    madePlaceholder.style.display = 'none';
  }
  
  // Store the original position of headers and their heights
  let antiquesOriginalTop = antiquesSection.offsetTop;
  let antiquesHeight = antiquesSection.clientHeight;
  let madeOriginalTop = hasMadeHeader ? madeHeader.offsetTop : 0;
  let madeHeight = hasMadeHeader ? madeHeader.clientHeight : 0;
  const logo = header.querySelector('.logo');
  
  // Get current values dynamically based on viewport
  function getCurrentHeaderSizes() {
    const isMobile = window.innerWidth <= 768;
    const logoHeight = parseFloat(window.getComputedStyle(logo).height);
    const headerHeight = parseFloat(window.getComputedStyle(header).height);
    
    return {
      maxLogoHeight: logoHeight,
      minLogoHeight: 32,
      maxHeaderHeight: headerHeight,
      minHeaderHeight: 50
    };
  }
  
  let sizes = getCurrentHeaderSizes();
  let logoHeightRange = sizes.maxLogoHeight - sizes.minLogoHeight;
  let headerHeightRange = sizes.maxHeaderHeight - sizes.minHeaderHeight;
  let transitionDistance = headerHeightRange;
  
  // Recalculate positions after images load to ensure accurate measurements
  window.addEventListener('load', () => {
    // Reset to clean state before measuring
    antiquesHeader.classList.remove('is-stuck');
    antiquesHeader.style.top = '';
    antiquesPlaceholder.style.display = 'none';
    if (hasMadeHeader) {
      madeHeader.classList.remove('is-stuck');
      madeHeader.style.top = '';
      madePlaceholder.style.display = 'none';
    }
    header.classList.remove('shrink');
    document.body.classList.remove('header-shrunk');
    logo.style.height = '';
    header.style.height = '';
    
    // Force reflow to ensure clean state
    void antiquesHeader.offsetHeight;
    
    // Now measure from clean state
    antiquesOriginalTop = antiquesSection.offsetTop;
    antiquesHeight = antiquesSection.clientHeight;
    if (hasMadeHeader) {
      madeOriginalTop = madeHeader.offsetTop;
      madeHeight = madeHeader.clientHeight;
    }
    sizes = getCurrentHeaderSizes();
    logoHeightRange = sizes.maxLogoHeight - sizes.minLogoHeight;
    headerHeightRange = sizes.maxHeaderHeight - sizes.minHeaderHeight;
    transitionDistance = headerHeightRange;
    
    // Apply correct state for current scroll position
    requestAnimationFrame(() => handleScroll());
  });
  
  // Recalculate positions on window resize (for orientation changes, etc.)
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Reset to non-stuck state temporarily to get accurate measurement
      antiquesHeader.classList.remove('is-stuck');
      antiquesHeader.style.top = '';
      antiquesPlaceholder.style.display = 'none';
      if (hasMadeHeader) {
        madeHeader.classList.remove('is-stuck');
        madeHeader.style.top = '';
        madePlaceholder.style.display = 'none';
      }
      header.classList.remove('shrink');
      document.body.classList.remove('header-shrunk');
      
      // Clear inline styles to get fresh CSS values
      logo.style.height = '';
      header.style.height = '';
      
      // Force a reflow
      void header.offsetHeight;
      
      // Recalculate all measurements based on new viewport
      antiquesOriginalTop = antiquesSection.offsetTop;
      antiquesHeight = antiquesSection.clientHeight;
      if (hasMadeHeader) {
        madeOriginalTop = madeHeader.offsetTop;
        madeHeight = madeHeader.clientHeight;
      }
      sizes = getCurrentHeaderSizes();
      logoHeightRange = sizes.maxLogoHeight - sizes.minLogoHeight;
      headerHeightRange = sizes.maxHeaderHeight - sizes.minHeaderHeight;
      transitionDistance = headerHeightRange;
      
      // Now trigger scroll handler to set correct state for current scroll position
      handleScroll();
    }, 100);
  });
  
  // Main scroll handler function
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Point A: when ANTIQUES reaches the bottom of the header
    const pointA = antiquesOriginalTop - sizes.maxHeaderHeight;
    // Point B: when transition is complete (header fully shrunk, ANTIQUES stuck)
    const pointB = pointA + transitionDistance;
    
    /* DEPRECATED (Jan 24, 2026): Point C no longer needed - MADE doesn't stick
    // Point C: when MADE reaches the bottom of the header (if it exists)
    const pointC = hasMadeHeader ? (madeOriginalTop - sizes.minHeaderHeight) : Infinity;
    */
    
    // DESKTOP/TABLET BEHAVIOR: Full shrinking animation
    if (scrollTop < pointA) {
      // Zone 1: Before point A - everything normal, explicitly reset all states
      antiquesHeader.classList.remove('is-stuck');
      antiquesHeader.style.top = '';
      antiquesPlaceholder.style.display = 'none';
      if (hasMadeHeader) {
        madeHeader.classList.remove('is-stuck');
        madeHeader.style.top = '';
        madePlaceholder.style.display = 'none';
      }
      logo.style.height = '';  // Clear inline style to use CSS default
      header.style.height = '';  // Clear inline style to use CSS default
      header.classList.remove('shrink');
      document.body.classList.remove('header-shrunk');
      
    } else if (scrollTop >= pointA && scrollTop < pointB) {
      // Zone 2: Between A and B - ANTIQUES scrolls naturally, KNOSEN shrinks
      antiquesHeader.classList.remove('is-stuck');
      antiquesHeader.style.top = '';
      antiquesPlaceholder.style.display = 'none';
      if (hasMadeHeader) {
        madeHeader.classList.remove('is-stuck');
        madeHeader.style.top = '';
        madePlaceholder.style.display = 'none';
      }
      
      // Calculate scroll progress (0 to 1) between A and B
      const scrollProgress = (scrollTop - pointA) / transitionDistance;
      
      // Calculate current sizes
      const currentLogoHeight = sizes.maxLogoHeight - (logoHeightRange * scrollProgress);
      const currentHeaderHeight = sizes.maxHeaderHeight - (headerHeightRange * scrollProgress);
      
      // Apply dynamic sizes - KNOSEN shrinks from the bottom
      logo.style.height = Math.round(currentLogoHeight * 100) / 100 + 'px';
      header.style.height = Math.round(currentHeaderHeight * 100) / 100 + 'px';
      
      header.classList.remove('shrink');
      document.body.classList.remove('header-shrunk');
      
    } else {
      // Zone 3: After B - Header remains shrunk, all sub-headers scroll normally
      // No sticky behavior - ANTIQUES only APPEARED to stick during the shrink animation
      antiquesHeader.classList.remove('is-stuck');
      antiquesHeader.style.top = '';
      antiquesPlaceholder.style.display = 'none';
      
      if (hasMadeHeader) {
        madeHeader.classList.remove('is-stuck');
        madeHeader.style.top = '';
        madePlaceholder.style.display = 'none';
      }
      
      logo.style.height = sizes.minLogoHeight + 'px';
      header.style.height = sizes.minHeaderHeight + 'px';
      header.classList.add('shrink');
      document.body.classList.add('header-shrunk');
    }
    
    /* DEPRECATED (Jan 24, 2026): Zone 4 logic removed - MADE no longer sticks
    } else if (scrollTop >= pointB && scrollTop < pointC) {
      // Zone 3: Between B and C - ANTIQUES stuck, MADE not yet visible
      antiquesHeader.classList.add('is-stuck');
      antiquesHeader.style.top = sizes.minHeaderHeight + 'px';
      antiquesPlaceholder.style.display = 'block';
      antiquesPlaceholder.style.height = antiquesHeight + 'px';
      if (hasMadeHeader) {
        madeHeader.classList.remove('is-stuck');
        madeHeader.style.top = '';
        madePlaceholder.style.display = 'none';
      }
      logo.style.height = sizes.minLogoHeight + 'px';
      header.style.height = sizes.minHeaderHeight + 'px';
      header.classList.add('shrink');
      document.body.classList.add('header-shrunk');
      
    } else {
      // Zone 4: After C - Both ANTIQUES and MADE stuck (MADE covers ANTIQUES with higher z-index)
      antiquesHeader.classList.add('is-stuck');
      antiquesHeader.style.top = sizes.minHeaderHeight + 'px';
      antiquesPlaceholder.style.display = 'block';
      antiquesPlaceholder.style.height = antiquesHeight + 'px';
      if (hasMadeHeader) {
        madeHeader.classList.add('is-stuck');
        madeHeader.style.top = sizes.minHeaderHeight + 'px';
        madePlaceholder.style.display = 'block';
        madePlaceholder.style.height = madeHeight + 'px';
      }
      logo.style.height = sizes.minLogoHeight + 'px';
      header.style.height = sizes.minHeaderHeight + 'px';
      header.classList.add('shrink');
      document.body.classList.add('header-shrunk');
    }
    */
  }
  
  // Attach scroll listener
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Run once on load to set initial state
  handleScroll();
  
  /* DEPRECATED (Jan 24, 2026): Recalculate function no longer needed - MADE doesn't stick
  // Expose recalculate function for AJAX content changes
  window.recalculateStickyHeaders = function() {
    if (!hasMadeHeader) return;
    
    // Recalculate MADE header position (ANTIQUES position shouldn't change)
    madeOriginalTop = madeHeader.offsetTop;
    madeHeight = madeHeader.clientHeight;
    
    // Trigger scroll handler to update positions
    handleScroll();
  };
  */
}

/**
 * Smooth scroll for anchor links
 */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    if (href === '#') return;
    
    e.preventDefault();
    const target = document.querySelector(href);
    
    if (target) {
      const headerHeight = document.getElementById('site-header').offsetHeight;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  });
});

/**
 * Mobile menu toggle (if needed in the future)
 */
function initMobileMenu() {
  // Placeholder for mobile menu functionality
}

/**
 * ============================================
 * CATEGORY CAROUSEL
 * ============================================
 */
/* ============================================
 * CATEGORY CAROUSEL
 * ============================================
 */
function initCategoryCarousel() {
  const carousel = document.querySelector('.category-carousel');
  const tiles = document.querySelector('.category-tiles');
  const prevBtn = document.querySelector('.carousel-prev');
  const nextBtn = document.querySelector('.carousel-next');
  
  if (!carousel || !tiles || !prevBtn || !nextBtn) return;
  
  let currentScroll = 0;
  let isScrolling = false;
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  
  // Update button visibility based on scroll position
  function updateButtons() {
    const maxScroll = tiles.scrollWidth - carousel.offsetWidth;
    
    // Hide prev button when at start
    if (currentScroll <= 0) {
      prevBtn.style.display = 'none';
    } else {
      prevBtn.style.display = 'flex';
    }
    
    // Hide next button when at end
    if (currentScroll >= maxScroll) {
      nextBtn.style.display = 'none';
    } else {
      nextBtn.style.display = 'flex';
    }
  }
  
  function scroll(direction) {
    // Allow multiple clicks - don't block if already scrolling
    
    const tileWidth = tiles.children[0].offsetWidth + 20; // width + gap
    const scrollAmount = tileWidth * 1; // Scroll one tile at a time
    const maxScroll = tiles.scrollWidth - carousel.offsetWidth;
    
    if (direction === 'next') {
      currentScroll = Math.min(currentScroll + scrollAmount, maxScroll);
    } else {
      currentScroll = Math.max(currentScroll - scrollAmount, 0);
    }
    
    tiles.style.transform = 'translateX(-' + currentScroll + 'px)';
    updateButtons();
  }
  
  // Touch/swipe support for mobile
  tiles.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    currentX = startX;
    isDragging = true;
    tiles.style.transition = 'none';
  });
  
  tiles.addEventListener('touchmove', function(e) {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
    const diff = currentX - startX;
    const maxScroll = tiles.scrollWidth - carousel.offsetWidth;
    const newScroll = Math.max(0, Math.min(currentScroll - diff, maxScroll));
    tiles.style.transform = 'translateX(-' + newScroll + 'px)';
  });
  
  tiles.addEventListener('touchend', function(e) {
    if (!isDragging) return;
    isDragging = false;
    
    const diff = currentX - startX;
    const maxScroll = tiles.scrollWidth - carousel.offsetWidth;
    
    // Update currentScroll to the final position after swipe
    currentScroll = Math.max(0, Math.min(currentScroll - diff, maxScroll));
    
    tiles.style.transition = 'transform 0.3s ease';
    tiles.style.transform = 'translateX(-' + currentScroll + 'px)';
    
    // Update button visibility after swipe
    setTimeout(function() {
      updateButtons();
    }, 300);
  });
  
  prevBtn.addEventListener('click', function() {
    scroll('prev');
  });
  
  nextBtn.addEventListener('click', function() {
    scroll('next');
  });
  
  // Initialize button visibility
  updateButtons();
  
  // Recalculate on resize
  window.addEventListener('resize', function() {
    updateButtons();
  });
}


/**
 * ============================================
 * MOBILE MENU FUNCTIONALITY
 * ============================================
 * 
 * Handles hamburger menu for small mobile screens (<580px)
 */
function initMobileMenu() {
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const menuClose = document.getElementById('mobile-menu-close');
  const mobileMenu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-menu-overlay');
  
  if (!menuToggle || !mobileMenu || !overlay) return;
  
  function openMenu() {
    mobileMenu.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  function closeMenu() {
    mobileMenu.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  menuToggle.addEventListener('click', openMenu);
  
  if (menuClose) {
    menuClose.addEventListener('click', closeMenu);
  }
  
  overlay.addEventListener('click', closeMenu);
  
  // Close menu when clicking a link
  const menuLinks = mobileMenu.querySelectorAll('a');
  menuLinks.forEach(function(link) {
    link.addEventListener('click', closeMenu);
  });
  
  // Close menu on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
      closeMenu();
    }
  });
}

/**
 * ============================================
 * MOBILE FILTER MENU FUNCTIONALITY
 * ============================================
 * 
 * Handles filter and sort menu for small mobile screens (<580px)
 */
function initMobileFilterMenu() {
  const filterToggle = document.getElementById('mobile-filter-toggle');
  const filterClose = document.getElementById('mobile-filter-close');
  const filterMenu = document.getElementById('mobile-filter-menu');
  const filterOverlay = document.getElementById('mobile-filter-overlay');
  const applyBtn = document.querySelector('.mobile-filter-apply');
  const resetBtn = document.querySelector('.mobile-filter-reset');
  
  if (!filterToggle || !filterMenu || !filterOverlay) return;
  
  function openFilterMenu() {
    filterMenu.classList.add('active');
    filterOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  function closeFilterMenu() {
    filterMenu.classList.remove('active');
    filterOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  filterToggle.addEventListener('click', openFilterMenu);
  
  if (filterClose) {
    filterClose.addEventListener('click', closeFilterMenu);
  }
  
  filterOverlay.addEventListener('click', closeFilterMenu);
  
  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && filterMenu.classList.contains('active')) {
      closeFilterMenu();
    }
  });
  
  // Handle apply button
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      // Sync mobile selections to main form
      const mobileSortSelect = document.querySelector('.mobile-sort-select');
      const mainSortSelect = document.getElementById('SortBy');
      
      if (mobileSortSelect && mainSortSelect) {
        mainSortSelect.value = mobileSortSelect.value;
      }
      
      // Sync checkboxes
      const mobileCheckboxes = filterMenu.querySelectorAll('input[type="checkbox"]');
      mobileCheckboxes.forEach(function(mobileCheckbox) {
        const name = mobileCheckbox.name;
        const mainCheckbox = document.querySelector('#FacetFiltersForm input[name="' + name + '"]');
        if (mainCheckbox) {
          mainCheckbox.checked = mobileCheckbox.checked;
        }
      });
      
      // Sync price inputs
      const mobilePriceInputs = filterMenu.querySelectorAll('input[type="number"]');
      mobilePriceInputs.forEach(function(mobilePriceInput) {
        const name = mobilePriceInput.name.replace('_mobile', '');
        const mainPriceInput = document.querySelector('#FacetFiltersForm input[name="' + name + '"]');
        if (mainPriceInput) {
          mainPriceInput.value = mobilePriceInput.value;
        }
      });
      
      // Trigger filter change to fetch results
      onFilterChange();
      
      closeFilterMenu();
    });
  }
  
  // Handle reset button
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      // Reset all checkboxes
      const checkboxes = filterMenu.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = false;
      });
      
      // Reset price inputs
      const priceInputs = filterMenu.querySelectorAll('input[type="number"]');
      priceInputs.forEach(function(input) {
        input.value = '';
      });
      
      // Reset sort to Featured
      const mobileSortSelect = document.querySelector('.mobile-sort-select');
      if (mobileSortSelect) {
        mobileSortSelect.value = 'manual';
      }
    });
  }
  
  // Sync mobile sort select changes to main select
  const mobileSortSelect = document.querySelector('.mobile-sort-select');
  if (mobileSortSelect) {
    mobileSortSelect.addEventListener('change', function() {
      const mainSortSelect = document.getElementById('SortBy');
      if (mainSortSelect) {
        mainSortSelect.value = this.value;
      }
    });
  }
}

/* ============================================
 * SEARCH MODAL
 * ============================================
 */
function initSearchModal() {
  const searchToggle = document.getElementById('search-toggle');
  const footerSearchToggle = document.getElementById('footer-search-toggle');
  const searchModal = document.getElementById('search-modal');
  const searchModalOverlay = document.getElementById('search-modal-overlay');
  const searchModalClose = document.getElementById('search-modal-close');
  const headerSearchInline = document.getElementById('header-search-inline');
  
  if (!searchModal || !searchModalOverlay || !searchModalClose) return;
  
  function openSearchModal() {
    searchModal.classList.add('active');
    searchModalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Focus the search input
    const searchInput = searchModal.querySelector('input[type="search"]');
    if (searchInput) {
      setTimeout(function() {
        searchInput.focus();
      }, 100);
    }
  }
  
  function closeSearchModal() {
    searchModal.classList.remove('active');
    searchModalOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  function toggleInlineSearch() {
    if (headerSearchInline) {
      const isActive = headerSearchInline.classList.contains('active');
      if (isActive) {
        headerSearchInline.classList.remove('active');
      } else {
        headerSearchInline.classList.add('active');
        // Focus the inline search input
        const searchInput = headerSearchInline.querySelector('input[type="search"]');
        if (searchInput) {
          setTimeout(function() {
            searchInput.focus();
          }, 100);
        }
      }
    }
  }
  
  function closeInlineSearch() {
    if (headerSearchInline) {
      headerSearchInline.classList.remove('active');
    }
  }
  
  // Header search button: inline on large desktop (1200px+), modal on smaller screens
  if (searchToggle) {
    searchToggle.addEventListener('click', function() {
      const isLargeDesktop = window.innerWidth >= 1200;
      if (isLargeDesktop) {
        toggleInlineSearch();
      } else {
        openSearchModal();
      }
    });
  }
  
  // Footer search button: always use modal
  if (footerSearchToggle) {
    footerSearchToggle.addEventListener('click', openSearchModal);
  }
  
  searchModalClose.addEventListener('click', closeSearchModal);
  searchModalOverlay.addEventListener('click', closeSearchModal);
  
  // Close inline search when clicking outside
  document.addEventListener('click', function(e) {
    if (headerSearchInline && headerSearchInline.classList.contains('active')) {
      const isClickInside = headerSearchInline.contains(e.target) || 
                           (searchToggle && searchToggle.contains(e.target));
      if (!isClickInside) {
        closeInlineSearch();
      }
    }
  });
  
  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (searchModal.classList.contains('active')) {
        closeSearchModal();
      }
      if (headerSearchInline && headerSearchInline.classList.contains('active')) {
        closeInlineSearch();
      }
    }
  });
}

// Product Gallery with Deferred Media
function initProductGallery() {
  const mainContainer = document.getElementById('productMediaMain');
  const thumbnails = document.querySelectorAll('.product-thumbnail');
  
  if (!mainContainer) return;
  
  // Initialize image zoom for main image (works even without thumbnails)
  initImageZoom();
  
  if (thumbnails.length === 0) return;
  
  // Preload all product images immediately
  function preloadAllImages() {
    const allTemplates = document.querySelectorAll('template[data-media-template]');
    allTemplates.forEach(template => {
      const content = template.content.cloneNode(true);
      const img = content.querySelector('img');
      if (img && img.src) {
        // Create hidden image to trigger browser cache
        const preloadImg = new Image();
        preloadImg.src = img.src;
      }
    });
  }
  
  // Start preloading immediately
  preloadAllImages();
  
  // Handle deferred media buttons
  function loadDeferredMedia(deferredMedia) {
    if (!deferredMedia || deferredMedia.classList.contains('loaded')) return;
    
    const template = deferredMedia.querySelector('template');
    if (!template) return;
    
    const content = template.content.cloneNode(true);
    deferredMedia.appendChild(content);
    deferredMedia.classList.add('loaded');
  }
  
  function initDeferredMedia(container) {
    const deferredMedia = container.querySelector('.deferred-media');
    if (!deferredMedia) return;
    
    const button = deferredMedia.querySelector('.deferred-media-button');
    if (!button) return;
    
    button.addEventListener('click', function() {
      loadDeferredMedia(deferredMedia);
    });
  }
  
  // Initialize any deferred media in the main container
  initDeferredMedia(mainContainer);
  
  // Set initial aspect ratio for main image
  const initialImage = mainContainer.querySelector('.main-product-image');
  if (initialImage) {
    if (initialImage.complete) {
      // Image already loaded
      const aspectRatio = initialImage.naturalWidth / initialImage.naturalHeight;
      mainContainer.style.aspectRatio = aspectRatio;
    } else {
      // Wait for image to load
      initialImage.addEventListener('load', function() {
        const aspectRatio = this.naturalWidth / this.naturalHeight;
        mainContainer.style.aspectRatio = aspectRatio;
      });
    }
  }
  
  // Handle arrow navigation
  const prevArrow = document.querySelector('.product-nav-prev');
  const nextArrow = document.querySelector('.product-nav-next');
  
  if (prevArrow && nextArrow && thumbnails.length > 1) {
    function navigateToMedia(direction) {
      const activeThumbnail = document.querySelector('.product-thumbnail.active');
      if (!activeThumbnail) return;
      
      const thumbnailsArray = Array.from(thumbnails);
      const currentIndex = thumbnailsArray.indexOf(activeThumbnail);
      let newIndex;
      
      if (direction === 'prev') {
        newIndex = currentIndex > 0 ? currentIndex - 1 : thumbnails.length - 1;
      } else {
        newIndex = currentIndex < thumbnails.length - 1 ? currentIndex + 1 : 0;
      }
      
      thumbnailsArray[newIndex].click();
    }
    
    prevArrow.addEventListener('click', function() {
      navigateToMedia('prev');
    });
    
    nextArrow.addEventListener('click', function() {
      navigateToMedia('next');
    });
  }
  
  // Handle thumbnail clicks
  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const mediaId = this.getAttribute('data-media-id');
      const mediaType = this.getAttribute('data-media-type');
      if (!mediaId) return;
      
      // Update active state
      thumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // Find the template for this media
      const template = document.querySelector(`template[data-media-template="${mediaId}"]`);
      if (!template) return;
      
      // Add loading state
      mainContainer.classList.add('loading');
      
      // Update aspect ratio class
      if (mediaType === 'video' || mediaType === 'external_video') {
        mainContainer.classList.add('video-active');
        mainContainer.style.aspectRatio = '';
      } else {
        mainContainer.classList.remove('video-active');
      }
      
      // Clone the new content
      const content = template.content.cloneNode(true);
      
      // For images, preload before swapping
      const newImage = content.querySelector('img');
      if (newImage && mediaType === 'image') {
        // Create a temporary image to preload
        const tempImg = new Image();
        tempImg.onload = function() {
          // Calculate and set aspect ratio based on image dimensions
          const aspectRatio = tempImg.naturalWidth / tempImg.naturalHeight;
          mainContainer.style.aspectRatio = aspectRatio;
          
          // Once loaded, swap content with fade
          mainContainer.innerHTML = '';
          mainContainer.appendChild(content);
          mainContainer.classList.remove('loading');
          initDeferredMedia(mainContainer);
          initImageZoom();
        };
        tempImg.src = newImage.src;
      } else {
        // For videos, swap immediately
        mainContainer.innerHTML = '';
        mainContainer.appendChild(content);
        mainContainer.classList.remove('loading');
        
        // If it's a video, auto-load it
        if (mediaType === 'video' || mediaType === 'external_video') {
          const deferredMedia = mainContainer.querySelector('.deferred-media');
          if (deferredMedia) {
            setTimeout(() => {
              loadDeferredMedia(deferredMedia);
            }, 50);
          }
        } else {
          initDeferredMedia(mainContainer);
        }
      }
    });
  });
}

/**
 * ============================================
 * QUANTITY SELECTOR
 * ============================================
 */
function initQuantitySelector() {
  const quantityInput = document.querySelector('.quantity-input');
  if (!quantityInput) return;
  
  const minusBtn = document.querySelector('.quantity-minus');
  const plusBtn = document.querySelector('.quantity-plus');
  const variantSelect = document.querySelector('.variant-selector select[name="id"]');

  function getInventoryLimit() {
    const inventorySource = variantSelect
      ? variantSelect.options[variantSelect.selectedIndex]
      : quantityInput;
    const inventoryQuantity = parseInt(inventorySource.dataset.inventoryQuantity, 10);
    const inventoryIsLimited = Boolean(inventorySource.dataset.inventoryManagement) &&
      inventorySource.dataset.inventoryPolicy === 'deny' &&
      !isNaN(inventoryQuantity);

    return inventoryIsLimited ? Math.max(inventoryQuantity, 0) : null;
  }

  function updateQuantityState() {
    const max = getInventoryLimit();
    let currentValue = parseInt(quantityInput.value, 10) || 1;

    if (max !== null) {
      quantityInput.setAttribute('max', max);
      if (currentValue > max) {
        currentValue = Math.max(max, 1);
        quantityInput.value = currentValue;
      }
    } else {
      quantityInput.removeAttribute('max');
    }

    if (minusBtn) {
      minusBtn.disabled = currentValue <= 1;
    }
    if (plusBtn) {
      plusBtn.disabled = max !== null && currentValue >= max;
    }
  }
  
  if (minusBtn) {
    minusBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
      updateQuantityState();
    });
  }
  
  if (plusBtn) {
    plusBtn.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      const max = getInventoryLimit();
      if (max !== null && currentValue < max) {
        quantityInput.value = currentValue + 1;
      } else if (max === null) {
        quantityInput.value = currentValue + 1;
      }
      updateQuantityState();
    });
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      quantityInput.value = 1;
      updateQuantityState();
    });
  }

  updateQuantityState();
}

/**
 * ============================================
 * IMAGE ZOOM
 * ============================================
 */
function initImageZoom() {
  const mainImage = document.querySelector('.main-product-image');
  if (!mainImage) return;
  
  // Disable zoom on mobile devices
  if (window.innerWidth <= 768) return;
  
  // Remove existing zoom event listeners if they exist
  if (mainImage._zoomInitialized) return;
  mainImage._zoomInitialized = true;
  
  mainImage.classList.add('zoomable');
  let isZoomed = false;
  
  const handleClick = function(e) {
    if (!isZoomed) {
      // Get click position relative to image
      const rect = this.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      
      // Set transform origin BEFORE adding zoom class
      this.style.transformOrigin = `${x}% ${y}%`;
      
      // Zoom in
      this.classList.add('zoomed');
      isZoomed = true;
    } else {
      // Zoom out
      this.classList.remove('zoomed');
      this.style.transformOrigin = 'center center';
      isZoomed = false;
    }
  };
  
  const handleMouseMove = function(e) {
    if (!isZoomed) return;
    
    const rect = this.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    this.style.transformOrigin = `${x}% ${y}%`;
  };
  
  const handleMouseLeave = function() {
    if (isZoomed) {
      this.classList.remove('zoomed');
      this.style.transformOrigin = 'center center';
      isZoomed = false;
    }
  };
  
  mainImage.addEventListener('click', handleClick);
  mainImage.addEventListener('mousemove', handleMouseMove);
  mainImage.addEventListener('mouseleave', handleMouseLeave);
}

/**
 * ============================================
 * FOOTER SCROLL DETECTION
 * ============================================
 * Hides the header when footer is approximately half visible
 * Shows large KNOSEN logo at bottom of footer
 */
function initFooterScrollDetection() {
  const header = document.getElementById('site-header');
  const antiquesHeader = document.getElementById('antiques-header');
  const madeHeader = document.getElementById('made-header');
  const footer = document.getElementById('site-footer');
  
  if (!header || !footer) return;
  
  let ticking = false;
  
  function checkFooterVisibility() {
    const footerRect = footer.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Calculate how much of the footer is visible
    const footerTop = footerRect.top;
    const footerHeight = footerRect.height;
    
    // When footer top is at roughly half the viewport (50% of footer visible)
    const triggerPoint = viewportHeight * 0.5;
    
    if (footerTop <= triggerPoint) {
      header.classList.add('footer-visible');
      if (antiquesHeader) {
        antiquesHeader.classList.add('footer-visible');
      }
      if (madeHeader) {
        madeHeader.classList.add('footer-visible');
      }
    } else {
      header.classList.remove('footer-visible');
      if (antiquesHeader) {
        antiquesHeader.classList.remove('footer-visible');
      }
      if (madeHeader) {
        madeHeader.classList.remove('footer-visible');
      }
    }
    
    ticking = false;
  }
  
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(checkFooterVisibility);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', onScroll);
  checkFooterVisibility(); // Check on load
}

// Initialize Category Product Loader (AJAX)
function initCategoryProductLoader() {
  const categoryTiles = document.querySelectorAll('.category-tile');
  const productsContainer = document.getElementById('category-products-container');
  const productsGrid = document.getElementById('category-products-grid');
  const loadingIndicator = document.getElementById('category-products-loading');
  const shopMoreContainer = document.getElementById('category-shop-more');
  const shopMoreLink = document.getElementById('category-shop-more-link');
  
  if (!categoryTiles.length || !productsContainer) return;
  
  categoryTiles.forEach(tile => {
    tile.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Reset all tiles to original images
      categoryTiles.forEach(t => {
        const img = t.querySelector('.category-tile-image img');
        const originalSrc = t.dataset.original;
        if (img && originalSrc) {
          img.src = originalSrc;
        }
      });
      
      // Set clicked tile to blue image
      const img = this.querySelector('.category-tile-image img');
      const blueSrc = this.dataset.blue;
      if (img && blueSrc) {
        img.src = blueSrc;
      }
      
      // Get collection handle from data-handle attribute or href
      const titleElement = this.querySelector('.category-tile-title');
      const handle = titleElement ? titleElement.dataset.handle : null;
      
      if (!handle) return;
      
      // Show container and loading state
      productsContainer.style.display = 'block';
      setTimeout(() => productsContainer.classList.add('active'), 10);
      loadingIndicator.style.display = 'block';
      productsGrid.innerHTML = '';
      shopMoreContainer.style.display = 'none';
      
      // Fetch products from collection
      fetch(`/collections/${handle}/products.json?limit=12`)
        .then(response => response.json())
        .then(data => {
          loadingIndicator.style.display = 'none';
          
          if (!data.products || data.products.length === 0) {
            productsGrid.innerHTML = '<p style="text-align: center; padding: 40px 0;">No products found in this category.</p>';
            return;
          }
          
          // Build product grid HTML
          const productHTML = data.products.map(product => {
            const firstVariant = product.variants[0];
            // Price is already in dollars from products.json
            const priceInDollars = parseFloat(firstVariant.price);
            // Format with commas and always show 2 decimal places
            const price = priceInDollars.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            const available = firstVariant.available;
            
            // Get images - Shopify returns image objects with src property
            // Optimize image size by adding Shopify's size parameter
            const getOptimizedImageUrl = (url) => {
              if (!url) return '';
              return url.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_800x.$1');
            };
            
            const firstImage = product.images[0] ? getOptimizedImageUrl(product.images[0].src) : '';
            const secondImage = product.images[1] ? getOptimizedImageUrl(product.images[1].src) : firstImage;
            
            return `
              <div class="product-card">
                <a href="/products/${product.handle}">
                  <div class="product-image">
                    <img src="${firstImage}" alt="${product.title}" class="product-image-primary" loading="lazy">
                    <img src="${secondImage}" alt="${product.title}" class="product-image-secondary" loading="lazy">
                    ${!available ? '<div class="sold-out-badge">SOLD</div>' : ''}
                  </div>
                  <h3 class="product-title">${product.title}</h3>
                  ${available ? `<p class="product-price">$${price}</p>` : ''}
                </a>
              </div>
            `;
          }).join('');
          
          productsGrid.innerHTML = productHTML;
          productsGrid.className = 'product-grid';
          
          // Show "View all" link if there might be more products
          // (if we got exactly 12, there could be more)
          if (data.products.length === 12) {
            const categoryName = titleElement ? titleElement.textContent : handle;
            shopMoreContainer.style.display = 'block';
            shopMoreLink.href = `/collections/${handle}`;
            shopMoreLink.textContent = `View all ${categoryName.toLowerCase()} →`;
          }
          
          // Scroll to products
          setTimeout(() => {
            productsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            
            /* DEPRECATED (Jan 24, 2026): No longer needed - MADE doesn't stick
            // Recalculate sticky header positions after content loads
            // Wait for layout to complete
            setTimeout(() => {
              if (window.recalculateStickyHeaders) {
                window.recalculateStickyHeaders();
              }
            }, 300);
            */
          }, 100);
        })
        .catch(error => {
          console.error('Error loading products:', error);
          loadingIndicator.style.display = 'none';
          productsGrid.innerHTML = '<p style="text-align: center; padding: 40px 0;">Error loading products. Please try again.</p>';
        });
    });
  });
}

// Initialize category tile image swapping for non-AJAX sections (e.g., shop page)
function initCategoryTileImageSwap() {
  const collectionCategoriesSection = document.querySelector('.collection-categories');
  if (!collectionCategoriesSection) return;
  
  const categoryTiles = collectionCategoriesSection.querySelectorAll('.category-tile');
  if (!categoryTiles.length) return;
  
  categoryTiles.forEach(tile => {
    tile.addEventListener('click', function(e) {
      // Reset all tiles to original images
      categoryTiles.forEach(t => {
        const img = t.querySelector('.category-tile-image img');
        const originalSrc = t.dataset.original;
        if (img && originalSrc) {
          img.src = originalSrc;
        }
      });
      
      // Set clicked tile to blue image
      const img = this.querySelector('.category-tile-image img');
      const blueSrc = this.dataset.blue;
      if (img && blueSrc) {
        img.src = blueSrc;
      }
    });
  });
}

// Initialize shop dropdown for touch/click interaction
function initShopDropdown() {
  const shopDropdown = document.querySelector('.shop-dropdown');
  if (!shopDropdown) return;
  
  const trigger = shopDropdown.querySelector('.shop-dropdown-trigger');
  const menu = shopDropdown.querySelector('.shop-dropdown-menu');
  
  if (!trigger || !menu) return;
  
  // Toggle dropdown on click/tap
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    shopDropdown.classList.toggle('active');
  });
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!shopDropdown.contains(e.target)) {
      shopDropdown.classList.remove('active');
    }
  });
  
  // Close dropdown when clicking a link inside
  menu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', function() {
      shopDropdown.classList.remove('active');
    });
  });
}

// Initialize parallax effect for Made collection full-width image
function initMadeParallax() {
  const parallaxImage = document.querySelector('.made-full-width-image');
  if (!parallaxImage) return;
  
  const imageSection = parallaxImage.parentElement;
  
  function updateParallax() {
    const rect = imageSection.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const sectionHeight = imageSection.offsetHeight;
    
    // Only apply parallax when section is in view
    if (rect.top < windowHeight && rect.bottom > 0) {
      // Progress: 0 when section enters bottom of viewport, 1 when it exits top
      const scrollProgress = (windowHeight - rect.top) / (windowHeight + sectionHeight);
      
      // Get aspect ratio from CSS variable
      const aspectRatio = parseFloat(getComputedStyle(imageSection).getPropertyValue('--parallax-image-aspect-ratio')) || 1;
      
      // Calculate actual rendered image height based on container width and aspect ratio
      const containerWidth = parallaxImage.offsetWidth;
      const imageHeight = containerWidth / aspectRatio;
      const maxOffset = Math.max(0, imageHeight - sectionHeight);
      
      const offset = scrollProgress * maxOffset;
      
      parallaxImage.style.transform = `translateY(-${offset}px)`;
      
      console.log({
        scrollProgress: scrollProgress.toFixed(3),
        offset: Math.round(offset),
        maxOffset: Math.round(maxOffset),
        imageHeight: Math.round(imageHeight),
        aspectRatio: aspectRatio.toFixed(2),
        sectionHeight: Math.round(sectionHeight)
      });
    }
  }
  
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        updateParallax();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  window.addEventListener('resize', updateParallax);
  updateParallax();
}

/**
 * ============================================
 * SMOOTH SCROLL FOR ANCHOR LINKS
 * ============================================
 */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

/**
 * ============================================
 * FAQ ACCORDION
 * ============================================
 */
function initFaqAccordion() {
  const faqQuestions = document.querySelectorAll('.made-faq-question');
  
  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const faqItem = this.closest('.made-faq-item');
      faqItem.classList.toggle('active');
    });
  });
}

function initSpecsAccordion() {
  const specsQuestions = document.querySelectorAll('.specs-accordion-question');
  
  specsQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      const specsAccordion = this.closest('.product-specs-accordion');
      specsAccordion.classList.toggle('active');
    });
  });
}
